document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.post-content table, .entry-content table, .prose table').forEach(table => {
        if (!table.closest('.table-wrapper, .wp-block-table')) {
            const wrapper = document.createElement('div');
            wrapper.className = 'table-wrapper';
            table.parentNode.insertBefore(wrapper, table);
            wrapper.appendChild(table);
        }
    });
});